/* ------------------------------------------------------------------------- */
/*  Header actions
/* ------------------------------------------------------------------------- */

import { Dropdown } from './dropdown';
import { slideDown, slideUp } from './slide';

import Swiper, { Autoplay, Pagination, Navigation } from 'swiper';
Swiper.use([Autoplay, Pagination, Navigation]);

import xhr from 'xhr';

let siteHeader = null;

function loadAlerts() {
  const stageLanguage = window.stageLanguage || document.documentElement.getAttribute('lang');
  const frontPage = document.body.classList.contains('page-frontpage') ? 1 : 0;

  xhr.get('/stage-ajax/getAlerts?stage-language='+stageLanguage+'&frontPage='+frontPage, function(err, resp) {
    if (resp && resp.body) {
      // Add element to body
      const div = document.createElement('div');
      div.classList.add('m-site-notification');
      div.innerHTML = resp.body;
      document.body.insertBefore(div, document.body.firstChild);

      // Initialize countdown element if found
      const countdownElem = document.getElementById('js-site-notification-countdown');
      if (countdownElem) {
        import('./countdown').then(({ Countdown }) => {
          new Countdown(countdownElem);
        });
      }

      const carouselElem = document.querySelector('.js-notification-slider');
      if (carouselElem) {
        const carouselSlides = carouselElem.getElementsByClassName('swiper-slide');
        if (carouselSlides.length > 1) {
          const carouselOptions = {
            autoplay: {
              delay: 4000,
            },
            effect: 'slide',
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            simulateTouch: true,
            loop: true,
            speed: 300
          };

          this.carousel = new Swiper(carouselElem, carouselOptions);

          div.classList.add('carousel-initialized');
        }
      }

      // Initialize accordions if found
      const accordionElems = document.querySelectorAll('.js-notification-accordion');
      for (let i = 0; i < accordionElems.length; i++) {
        const accordionHeader = accordionElems[i].querySelector('.js-notification-accordion-header');
        const accordionContent = accordionElems[i].querySelector('.js-notification-accordion-content');
        accordionHeader.addEventListener('click', (e) => {
          const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
          if (width < 992) { // Only in mobile
            e.preventDefault();
            e.stopPropagation();

            if (accordionElems[i].classList.contains('is-open')) {
              slideUp(accordionContent, 400, function(){
                accordionElems[i].classList.remove('is-open');
              });
            } else {
              slideDown(accordionContent, 400, function(){
                accordionElems[i].classList.add('is-open');
              });
            }
          }
        });
      }
    }
  });
}

function onOpen(elem) {
  document.body.classList.add('fullscreen');
  siteHeader.classList.add('is-open');
}

function onClose(elem) {
  document.body.classList.remove('fullscreen');
  siteHeader.classList.remove('is-open');
}

function initNavigation() {
  // Mobile menu
  const mobileMenu = document.getElementsByClassName('js-main-nav');
  const mobileMenuToggle = document.getElementsByClassName('js-menu-toggle');
  if (mobileMenu.length && mobileMenuToggle.length) {
    new Dropdown(mobileMenu[0], {
      button: mobileMenuToggle,
      callbackOpen: onOpen,
      callbackClose: onClose
    });
  }

  // Dropdown menu toggles
  const navItemDropdownTriggers = document.getElementsByClassName('m-main-nav__list-dropdown-trigger');
  for (var i = 0; i < navItemDropdownTriggers.length; i++) {
    navItemDropdownTriggers[i].addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const item = e.target.closest('.m-main-nav__list-item');
      const isToggled = item.classList.contains('is-toggled');

      // Find sub navigation to animate
      let subNav = null;
      for (var x = 0; x < item.childNodes.length; x++) {
        const childClasses = typeof item.childNodes[x].className !== 'undefined' ? item.childNodes[x].className.split(' ') : [];
        if (childClasses.indexOf('m-main-nav__list') !== -1) {
          subNav = item.childNodes[x];
          break;
        }
      }

      if (isToggled) {
        if (subNav) {
          slideUp(subNav, 400, function(){
            item.classList.remove('is-toggled');
          });
        } else {
          item.classList.remove('is-toggled');
        }
      } else {
        if (subNav) {
          slideDown(subNav, 400, function(){
            item.classList.add('is-toggled');
          });
        } else {
          item.classList.add('is-toggled');
        }
      }
    });
  }
}

function init() {
  loadAlerts();

  siteHeader = document.querySelector('.o-site-header');

  // Site search toggle
  const siteSearch = document.getElementsByClassName('js-site-search');
  const siteSearchToggle = document.getElementsByClassName('js-site-search-toggle');
  if (siteSearch.length && siteSearchToggle.length) {
    new Dropdown(siteSearch[0], {
      button: siteSearchToggle,
      callbackOpen: function() {
        document.getElementById('q').focus();
        onOpen();
      },
      callbackClose: onClose
    });
  }

  // Shopping cart toggle
  const shoppingCart = document.getElementsByClassName('js-header-cart');
  if (siteSearch.length) {
    new Dropdown(shoppingCart[0], {
      triggerInside: '.js-cart-toggle',
      callbackOpen: onOpen,
      callbackClose: onClose
    });
  }

  // Main navigation
  initNavigation();
}

export default {
  init: init
}
